import { Store } from '@ngrx/store';
import { inject, Injectable } from '@angular/core';
import {
  selectUpsellingIsLoaded,
  selectUpsellingIsLoading,
  selectUpsellingHasError,
  selectUpsellingError,
  selectUpsellingProposalsProductsByTriggerProductId,
  selectUpsellingMappingByTriggerProductId,
} from '@store/upselling/upselling.selector';

@Injectable({ providedIn: 'root' })
export class UpsellingStoreSelector {
  private readonly store = inject(Store);

  selectIsLoaded = this.store.selectSignal(selectUpsellingIsLoaded);
  selectIsLoading = this.store.selectSignal(selectUpsellingIsLoading);
  selectHasError = this.store.selectSignal(selectUpsellingHasError);
  selectError = this.store.selectSignal(selectUpsellingError);

  selectProposalsByTriggerProductId(triggerProductId: string) {
    return this.store.selectSignal(
      selectUpsellingProposalsProductsByTriggerProductId(triggerProductId),
    );
  }

  selectMappingByTriggerProductId(triggerProductId: string) {
    return this.store.selectSignal(selectUpsellingMappingByTriggerProductId(triggerProductId));
  }
}
